import moment from 'moment';

/**
 * Booking Status Colors
 * - bg/shadow: legacy gradient chips elsewhere
 * - fill: solid calendar bar fill (high contrast with white text)
 * - line: accent / legend color
 */
export const getStatusColors = (status, isDarkMode = false) => {
  const colors = {
    checked_in: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #4caf50 0%, #2e7d32 42%, #1b5e20 100%)'
        : 'linear-gradient(128deg, #81c784 0%, #43a047 38%, #2e7d32 100%)',
      fill: isDarkMode ? '#2f9e44' : '#2b8a3e',
      text: '#ffffff',
      line: isDarkMode ? '#51cf66' : '#2b8a3e',
      shadow: isDarkMode
        ? '0 4px 14px rgba(46, 125, 50, 0.45), inset 0 1px 0 rgba(255,255,255,0.12)'
        : '0 4px 16px rgba(46, 125, 50, 0.28), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    checked_out: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #757575 0%, #616161 45%, #424242 100%)'
        : 'linear-gradient(128deg, #bdbdbd 0%, #9e9e9e 40%, #757575 100%)',
      fill: isDarkMode ? '#868e96' : '#868e96',
      text: '#ffffff',
      line: isDarkMode ? '#adb5bd' : '#868e96',
      shadow: isDarkMode
        ? '0 4px 12px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.08)'
        : '0 4px 14px rgba(97, 97, 97, 0.22), inset 0 1px 0 rgba(255,255,255,0.4)',
    },
    booked: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #ff9800 0%, #f57c00 45%, #e65100 100%)'
        : 'linear-gradient(128deg, #ffb74d 0%, #ff9800 38%, #f57c00 100%)',
      fill: isDarkMode ? '#f08c00' : '#e67700',
      text: '#ffffff',
      line: isDarkMode ? '#ffb74d' : '#e67700',
      shadow: isDarkMode
        ? '0 4px 14px rgba(245, 124, 0, 0.4)'
        : '0 4px 16px rgba(255, 152, 0, 0.32), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    confirmed: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #ffb74d 0%, #ff9800 42%, #e65100 100%)'
        : 'linear-gradient(128deg, #ffe082 0%, #ffb300 35%, #ff8f00 100%)',
      fill: isDarkMode ? '#f59f00' : '#e8590c',
      text: '#ffffff',
      line: isDarkMode ? '#ffc078' : '#e8590c',
      shadow: isDarkMode
        ? '0 4px 14px rgba(255, 152, 0, 0.4)'
        : '0 4px 16px rgba(255, 179, 0, 0.3), inset 0 1px 0 rgba(255,255,255,0.45)',
    },
    partial_checkin: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #4caf50 0%, #2e7d32 42%, #1b5e20 100%)'
        : 'linear-gradient(128deg, #81c784 0%, #43a047 38%, #2e7d32 100%)',
      fill: isDarkMode ? '#2f9e44' : '#2b8a3e',
      text: '#ffffff',
      line: isDarkMode ? '#51cf66' : '#2b8a3e',
      shadow: isDarkMode
        ? '0 4px 14px rgba(46, 125, 50, 0.45), inset 0 1px 0 rgba(255,255,255,0.12)'
        : '0 4px 16px rgba(46, 125, 50, 0.28), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    partial_checkout: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #78909c 0%, #546e7a 50%, #37474f 100%)'
        : 'linear-gradient(128deg, #a5d6a7 0%, #66bb6a 28%, #43a047 72%, #2e7d32 100%)',
      fill: isDarkMode ? '#0ca678' : '#0b7285',
      text: '#ffffff',
      line: isDarkMode ? '#3bc9db' : '#0b7285',
      shadow: isDarkMode
        ? '0 4px 14px rgba(55, 71, 79, 0.4)'
        : '0 4px 16px rgba(46, 125, 50, 0.22), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    pending: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #ffa726 0%, #fb8c00 50%, #ef6c00 100%)'
        : 'linear-gradient(128deg, #ffcc80 0%, #ffa726 40%, #fb8c00 100%)',
      fill: isDarkMode ? '#f08c00' : '#d9480f',
      text: '#ffffff',
      line: isDarkMode ? '#ffb74d' : '#d9480f',
      shadow: isDarkMode
        ? '0 4px 14px rgba(251, 140, 0, 0.4)'
        : '0 4px 16px rgba(255, 152, 0, 0.3), inset 0 1px 0 rgba(255,255,255,0.45)',
    },
    reserved: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #7e57c2 0%, #5e35b1 50%, #4527a0 100%)'
        : 'linear-gradient(128deg, #b39ddb 0%, #7e57c2 42%, #5e35b1 100%)',
      fill: isDarkMode ? '#7950f2' : '#5f3dc4',
      text: '#ffffff',
      line: isDarkMode ? '#b197fc' : '#5f3dc4',
      shadow: isDarkMode
        ? '0 4px 14px rgba(94, 53, 177, 0.4)'
        : '0 4px 16px rgba(103, 58, 183, 0.26), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    blocked: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #ef5350 0%, #c62828 50%, #b71c1c 100%)'
        : 'linear-gradient(128deg, #ff8a80 0%, #f44336 42%, #c62828 100%)',
      fill: isDarkMode ? '#fa5252' : '#c92a2a',
      text: '#ffffff',
      line: isDarkMode ? '#ff8787' : '#c92a2a',
      shadow: isDarkMode
        ? '0 4px 14px rgba(198, 40, 40, 0.45)'
        : '0 4px 16px rgba(244, 67, 54, 0.32), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    web_checkin: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #26a69a 0%, #00897b 50%, #00695c 100%)'
        : 'linear-gradient(128deg, #80cbc4 0%, #26a69a 42%, #00897b 100%)',
      fill: isDarkMode ? '#12b886' : '#0ca678',
      text: '#ffffff',
      line: isDarkMode ? '#38d9a9' : '#0ca678',
      shadow: isDarkMode
        ? '0 4px 14px rgba(0, 137, 123, 0.45)'
        : '0 4px 16px rgba(38, 166, 154, 0.28), inset 0 1px 0 rgba(255,255,255,0.35)',
    },
    cancelled: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #8d6e63 0%, #5d4037 50%, #3e2723 100%)'
        : 'linear-gradient(128deg, #e57373 0%, #e53935 45%, #b71c1c 100%)',
      fill: isDarkMode ? '#a61e4d' : '#a61e4d',
      text: '#ffffff',
      line: isDarkMode ? '#e64980' : '#a61e4d',
      shadow: isDarkMode
        ? '0 4px 12px rgba(62, 39, 35, 0.45)'
        : '0 4px 14px rgba(229, 57, 53, 0.28)',
    },
    no_show: {
      bg: isDarkMode
        ? 'linear-gradient(128deg, #8d6e63 0%, #5d4037 50%, #3e2723 100%)'
        : 'linear-gradient(128deg, #e57373 0%, #e53935 45%, #b71c1c 100%)',
      fill: isDarkMode ? '#862e9c' : '#862e9c',
      text: '#ffffff',
      line: isDarkMode ? '#cc5de8' : '#862e9c',
      shadow: isDarkMode
        ? '0 4px 12px rgba(62, 39, 35, 0.45)'
        : '0 4px 14px rgba(229, 57, 53, 0.28)',
    },
  };
  const picked = colors[status] || colors.booked;
  return {
    ...picked,
    fill: picked.fill || picked.line || (isDarkMode ? '#f08c00' : '#e67700'),
    line: picked.line ?? (isDarkMode ? '#ffb74d' : '#f57c00'),
  };
};

/**
 * Priority for resolving overlapping statuses on the same room/date.
 * Higher number means higher rendering priority.
 */
/**
 * Same idea as ultra view: statuses that still "hold" the room for allocation purposes.
 * Checked-out / cancelled / no-show rooms can receive another provisional placement.
 */
export const isBlockingBookingStatus = (status) => {
  const s = String(status || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_');
  return !['checked_out', 'cancelled', 'canceled', 'no_show'].includes(s);
};

export const getBookingStatusPriority = (status, itemStatus = null) => {
  const normalizedStatus = String(itemStatus || status || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_');
  switch (normalizedStatus) {
    case 'blocked':
      // Inventory blocks paint above same-day checkout / arrival bars when stacked.
      return 110;
    case 'checked_in':
    case 'partial_checkin':
      return 100;
    case 'confirmed':
      return 90;
    case 'partial_checkout':
      return 80;
    case 'checked_out':
      return 70;
    case 'pending':
    case 'reserved':
      return 60;
    // Lowest display priority on room cards — never beat checkout / other stays.
    case 'cancelled':
    case 'canceled':
    case 'no_show':
      return 10;
    default:
      return 50;
  }
};

/**
 * Get booking source icon component name
 * Returns the icon component identifier for use in components
 */
export const getBookingSourceIconName = (bookingSource) => {
  switch (bookingSource) {
    case 'reservation':
      return 'event';
    case 'walk_in':
      return 'personAdd';
    default:
      return 'hotel';
  }
};

/**
 * Format date to YYYY-MM-DD string
 */
export const formatDateString = (date) => {
  return moment(date).format('YYYY-MM-DD');
};

/**
 * Create a booking key for deduplication
 */
export const createBookingKey = (bookingId, checkInStr, checkOutStr) => {
  return `${bookingId}_${checkInStr}_${checkOutStr}`;
};

/**
 * Create a room allocation key
 */
export const createRoomAllocationKey = (roomId, checkInStr, checkOutStr) => {
  return `${roomId}_${checkInStr}_${checkOutStr}`;
};

/**
 * Extract numeric part from room number for sorting
 */
export const extractRoomNumber = (room) => {
  return parseInt(room.room_number?.replace(/\D/g, '') || room.id) || room.id;
};

/**
 * Sort rooms by room number
 */
export const sortRoomsByNumber = (rooms) => {
  return [...rooms].sort((a, b) => {
    const numA = extractRoomNumber(a);
    const numB = extractRoomNumber(b);
    return numA - numB;
  });
};

/**
 * Check if two date ranges overlap
 */
export const dateRangesOverlap = (start1, end1, start2, end2) => {
  const start1Moment = moment(start1);
  const end1Moment = moment(end1);
  const start2Moment = moment(start2);
  const end2Moment = moment(end2);
  
  return start1Moment.isSameOrBefore(end2Moment, 'day') && 
         end1Moment.isSameOrAfter(start2Moment, 'day');
};

/**
 * Check if a room has any booking overlapping with a given date range
 * @param {Array} existingBars - Array of existing booking bars for a room
 * @param {moment} checkIn - Check-in date
 * @param {moment} checkOut - Check-out date
 * @returns {boolean} True if there's an overlap
 */
export const hasOverlappingBooking = (existingBars, checkIn, checkOut) => {
  if (!existingBars || existingBars.length === 0) return false;
  
  return existingBars.some(bar => {
    return dateRangesOverlap(
      checkIn,
      checkOut,
      bar.startDate,
      bar.endDate
    );
  });
};

/**
 * Check if a booking is duplicate (same booking ID, same room, same date range)
 * @param {Array} existingBars - Array of existing booking bars for a room
 * @param {number} bookingId - Booking ID to check
 * @param {moment} checkIn - Check-in date
 * @param {moment} checkOut - Check-out date
 * @returns {boolean} True if duplicate found
 */
/**
 * Room allocation / check-in stats for edit booking / status transitions.
 * Mirrors backend get_rooms_count / get_allocated_rooms_count / get_checked_in_rooms_count.
 */
export const getBookingRoomAllocationStats = (bookingItems = [], fallbackTotalRooms = 1) => {
  const activeItems = (bookingItems || []).filter(
    (item) => item?.checkout !== true && item?.room_type_id != null
  );
  const allStreams = new Set();
  const allocatedStreams = new Set();
  const checkedInStreams = new Set();

  activeItems.forEach((item) => {
    const streamKey = `${item.room_type_id}-${item.room_sequence ?? 1}`;
    allStreams.add(streamKey);
    if (Number(item.allocated_room_id || 0) > 0) {
      allocatedStreams.add(streamKey);
    }
    if (item?.checked_in === true || item?.checked_in === 1 || item?.checked_in === 'true') {
      checkedInStreams.add(streamKey);
    }
  });

  const totalRooms = allStreams.size > 0
    ? allStreams.size
    : Math.max(1, Number(fallbackTotalRooms) || 1);
  const allocatedRooms = allocatedStreams.size;
  const checkedInRooms = checkedInStreams.size;

  return {
    totalRooms,
    allocatedRooms,
    checkedInRooms,
    hasAllocatedRooms: allocatedRooms > 0,
    allRoomsAllocated: allocatedRooms > 0 && allocatedRooms >= totalRooms,
    hasCheckedInRooms: checkedInRooms > 0,
    allRoomsCheckedIn: checkedInRooms > 0 && checkedInRooms >= totalRooms,
  };
};

export const isDuplicateBooking = (existingBars, bookingId, checkIn, checkOut) => {
  if (!existingBars || existingBars.length === 0) return false;

  const checkInStr = formatDateString(checkIn);
  const checkOutStr = formatDateString(checkOut);

  return existingBars.some((bar) => {
    if (!bar.booking || Number(bar.booking.id) !== Number(bookingId)) return false;

    const barCheckInStr = formatDateString(bar.startDate);
    const barCheckOutStr = formatDateString(bar.endDate);

    if (barCheckInStr === checkInStr && barCheckOutStr === checkOutStr) return true;
    // Same booking on same room: overlapping or identical spans (e.g. merged map + stray segment).
    return dateRangesOverlap(bar.startDate, bar.endDate, checkIn, checkOut);
  });
};

/**
 * Upgrade vs downgrade from room-type sort_order (higher = premium).
 * Equal / missing / default 0 → treat as upgrade (same message).
 */
export const resolveRoomTypeChangeKind = (fromTypeId, toTypeId, sortOrderByTypeId = {}) => {
  const fromId = Number(fromTypeId) || 0;
  const toId = Number(toTypeId) || 0;
  if (!fromId || !toId || fromId === toId) return 'upgrade';
  const fromSort = Number(
    sortOrderByTypeId[fromId] ?? sortOrderByTypeId[String(fromId)] ?? 0,
  );
  const toSort = Number(
    sortOrderByTypeId[toId] ?? sortOrderByTypeId[String(toId)] ?? 0,
  );
  if (Number.isFinite(toSort) && Number.isFinite(fromSort) && toSort < fromSort) {
    return 'downgrade';
  }
  return 'upgrade';
};

export const getRoomTypeChangeLabel = (kind) => (
  kind === 'downgrade' ? 'Downgrade' : 'Upgrade'
);

export const getRoomTypeChangeMessage = (kind) => (
  kind === 'downgrade'
    ? 'Room type downgraded for this stay'
    : 'Room type upgraded for this stay'
);

/** Build id → sort_order map from room type objects / booking items. */
export const buildRoomTypeSortOrderMap = (roomTypesOrItems = []) => {
  const map = {};
  (roomTypesOrItems || []).forEach((entry) => {
    if (!entry) return;
    const rt = entry.room_type && typeof entry.room_type === 'object'
      ? entry.room_type
      : entry;
    const id = Number(rt?.id ?? entry.room_type_id ?? 0);
    if (!id) return;
    const sort = Number(rt?.sort_order ?? entry.sort_order ?? 0);
    if (map[id] == null) map[id] = Number.isFinite(sort) ? sort : 0;
  });
  return map;
};

/** Build id → room type display name map. */
export const buildRoomTypeNameMap = (roomTypesOrItems = []) => {
  const map = {};
  (roomTypesOrItems || []).forEach((entry) => {
    if (!entry) return;
    const rt = entry.room_type && typeof entry.room_type === 'object'
      ? entry.room_type
      : entry;
    const id = Number(rt?.id ?? entry.room_type_id ?? 0);
    if (!id) return;
    const name = String(rt?.name ?? entry.room_type_name ?? '').trim();
    if (name && map[id] == null) map[id] = name;
  });
  return map;
};

/**
 * Resolve upgrade/downgrade for a room's booking items using sort_order.
 * Prefers explicit upgraded_from_room_type_id; falls back to earlier type in sequence.
 */
export const resolveRoomTypeChangeKindFromItems = (
  items,
  sortOrderByTypeId = {},
  allSequenceItems = null,
) => {
  const list = Array.isArray(items) ? items : [];
  if (!list.length) return 'upgrade';

  const getTypeId = (item) => Number(
    (item?.room_type_id ?? item?.room_type?.id) || 0,
  );
  const getFromId = (item) => Number(
    (item?.upgraded_from_room_type_id ?? item?.upgraded_from_room_type?.id) || 0,
  );
  const getDateKey = (item) => {
    if (!item?.date) return '';
    if (moment.isMoment(item.date)) return item.date.format('YYYY-MM-DD');
    return String(item.date).slice(0, 10);
  };

  const marked = list.find((item) => {
    const toId = getTypeId(item);
    const fromId = getFromId(item);
    return toId && fromId && fromId !== toId;
  });
  if (marked) {
    return resolveRoomTypeChangeKind(getFromId(marked), getTypeId(marked), sortOrderByTypeId);
  }

  const toItem = [...list].sort((a, b) => getDateKey(b).localeCompare(getDateKey(a)))[0];
  const toId = getTypeId(toItem);
  if (!toId) return 'upgrade';

  const seq = Number(toItem?.room_sequence || 1);
  const pool = Array.isArray(allSequenceItems) ? allSequenceItems : list;
  const prior = pool
    .filter((item) => {
      const typeId = getTypeId(item);
      if (!typeId || typeId === toId) return false;
      if (Number(item?.room_sequence || 1) !== seq) return false;
      const d = getDateKey(item);
      const toDate = getDateKey(toItem);
      return d && toDate && d < toDate;
    })
    .sort((a, b) => getDateKey(b).localeCompare(getDateKey(a)))[0];

  const fromId = prior ? getTypeId(prior) : 0;
  return resolveRoomTypeChangeKind(fromId, toId, sortOrderByTypeId);
};

/** True when guest DOB indicates age under 18 (or API marks is_child). */
export const isGuestChild = (guestOrDob) => {
  if (guestOrDob == null) return false;
  if (typeof guestOrDob === 'object' && guestOrDob.is_child === true) return true;
  const dob = typeof guestOrDob === 'string' || typeof guestOrDob === 'number'
    ? guestOrDob
    : (guestOrDob.dob || guestOrDob.date_of_birth);
  if (!dob) return false;
  const m = moment(dob);
  if (!m.isValid()) return false;
  return moment().diff(m, 'years') < 18;
};
